import axios from "axios";
import useAsync from "./useAsync";

export default function useFetch(url, options = {}, dependencies = [], rebuildArray = (value) => value) {
  return useAsync(() => {
    return axios
      .get(url, options)
      .then((res) => {
        if (res.data) {
          return Promise.resolve(rebuildArray(res.data));
        }
      })
      .catch((err) => {
        return Promise.reject(err.response?.data || "Something wrong");
      });
  }, dependencies);
}
